import { render, staticRenderFns } from "./TipoVehiculoLinea.vue?vue&type=template&id=2e6ac237"
import script from "./TipoVehiculoLinea.vue?vue&type=script&lang=js"
export * from "./TipoVehiculoLinea.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports